/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as SafelinkDefs from './defs.defs.js'

const $nsid = 'tools.ozone.safelink.updateRule'

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $input = /*#__PURE__*/ l.jsonPayload({
  url: /*#__PURE__*/ l.string(),
  pattern: /*#__PURE__*/ l.ref<SafelinkDefs.PatternType>(
    (() => SafelinkDefs.patternType) as any,
  ),
  action: /*#__PURE__*/ l.ref<SafelinkDefs.ActionType>(
    (() => SafelinkDefs.actionType) as any,
  ),
  reason: /*#__PURE__*/ l.ref<SafelinkDefs.ReasonType>(
    (() => SafelinkDefs.reasonType) as any,
  ),
  comment: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  createdBy: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string({ format: 'did' }),
  ),
})

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>

export const $output = /*#__PURE__*/ l.payload(
  'application/json',
  /*#__PURE__*/ l.ref<SafelinkDefs.Event>((() => SafelinkDefs.event) as any),
)

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Update an existing URL safety rule */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output, [
  'RuleNotFound',
])

export { main }

export const $lxm = $nsid
